import { useCallback, useState } from "react";

interface SelectableTask {
  id: string;
  status: string;
}

export const usePickTaskSelection = () => {
  const [selectedTaskIds, setSelectedTaskIds] = useState<Set<string>>(
    new Set()
  );

  const handleSelectTask = useCallback((taskId: string) => {
    setSelectedTaskIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(taskId)) {
        newSet.delete(taskId);
      } else {
        newSet.add(taskId);
      }
      return newSet;
    });
  }, []);

  const handleSelectAll = useCallback((tasks: SelectableTask[]) => {
    setSelectedTaskIds((prev) => {
      const selectableTasks = tasks.filter((t) => t.status !== "in_progress");
      const allSelected = selectableTasks.every((t) => prev.has(t.id));
      if (allSelected) {
        return new Set();
      } else {
        return new Set(selectableTasks.map((t) => t.id));
      }
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedTaskIds(new Set());
  }, []);

  const isAllSelected = useCallback(
    (tasks: SelectableTask[]) => {
      const selectableTasks = tasks.filter((t) => t.status !== "in_progress");
      return (
        selectableTasks.length > 0 &&
        selectableTasks.every((t) => selectedTaskIds.has(t.id))
      );
    },
    [selectedTaskIds]
  );

  return {
    selectedTaskIds,
    handleSelectTask,
    handleSelectAll,
    clearSelection,
    isAllSelected,
    selectedCount: selectedTaskIds.size,
  };
};
